/* istanbul ignore file */
const { httpClient } = require("../factory.api.js");

const getCaseDevices = () =>
  httpClient
    .get(`/catalog/case_devices/available`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

export { getCaseDevices };
